import { invertObject } from '@/utils'
import * as NOTIF from '@/utils/constants/notification-types'
import timeAgo from '@/modules/time-ago'
import i18n from '@/plugins/i18n'
import { TX_STATES } from '@/utils/constants'

const STATES_TX = invertObject(TX_STATES)

export default {
  [NOTIF.USER_MUTED](data, model) {
    const expiresAt = new Date(model.timestamp + data.duration)

    return {
      duration: timeAgo.format(new Date(Date.now() + data.duration), 'mini'),
      timeLeft: timeAgo.format(expiresAt > Date.now() ? expiresAt : new Date()),
      reason: data.reason.replace(/^for /, ''),
    }
  },
  [NOTIF.TRADE_OFFER_PENDING](data) {
    const { tradeId } = data

    const ctaText = i18n.t('cta.click_here')

    return {
      tradeId: data.tradeId,
      link: `<a
        class="link primary500--text"
        href="https://steamcommunity.com/tradeoffer/${tradeId}"
        target="_blank"
        rel="noopener noreferrer"
      >${ctaText}</a>`,
    }
  },
  [NOTIF.TX_STATUS](data) {
    return {
      method: i18n.t(`common.tx_method.${data.method}`),
      status: i18n.t(`common.tx_status.${STATES_TX[data.status]}`),
      type: data.type,
    }
  },
  [NOTIF.LB_REWARDS](data) {
    const amount = (data.amount / 100).toLocaleString(i18n.locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })

    return { amount }
  },
}
